import { DateTime } from 'luxon';
import { Modalidade } from '../..';
import {
  OnboardingModalidade,
  OnboardingPlataforma,
} from '../../contexts/config/internal/marcas-configs/service/consultar-configuracoes-marca.types';

export interface BibliotecaVirtual {
  title: string;
  url: string;
  descricao: string;
}

export enum OpcoesAjuda {
  FAQ = 'FAQ',
  MANUAL = 'MANUAL',
  NAAP = 'NAAP',
}

export interface ItemConfig {
  titulo: string;
  url: string;
}

export interface OpcoesMenuAjuda extends ItemConfig {
  tagGA: string;
  modalidade?: Modalidade;
  tipo?: OpcoesAjuda;
  tipoVisualizacao?: 'EXTERNO' | 'MODAL';
}

export type ItemMenuConfigValues =
  | 'home'
  | 'disciplinas'
  | 'biblioteca-virtual'
  | 'empregabilidade'
  | 'calendario-academico'
  | 'ajuda'
  | 'exercicios'
  | 'avaliacoes'
  | 'campus-sia'
  | 'acessibilidade';

export type TipoAvaliacao = 'simulado' | 'av' | 'avs';

export interface Avaliacao {
  tipo: TipoAvaliacao;
  dataInicio: DateTime;
  dataFim: DateTime;
}

export interface Configs {
  contexto: string;
  ambiente: string;
  marca: string;
  idClienteEnsineme: string;
  API: string;
  API_DEDICADA: string;
  API_V2: string;
  URL_QC: string;
  URL_REDIRECT_ENSINEME: string;
  URL_EDUCADOR: string;
  URL_FAQ: string;
  URL_MANUAL: string;
  URL_BASE_CALENDARIO_ACADEMICO: string;
  EXTENSOES_VALIDAS_ENVIO_ARQUIVO: string[];
  userManagerSettings: {
    authority: string;
    client_id: string;
    redirect_uri: string;
    post_logout_redirect_uri: string;
    monitorSession: boolean;
    userStore: unknown;
    prompt: string;
    response_type: string;
    automaticSilentRenew: boolean;
    loadUserInfo: boolean;
    scope: string;
  };
  GTM_ID: string;
  TAMANHO_PAGINA_RESPOSTA_TRABALHOS: number;
  BIBLIOTECA_VIRTUAL: BibliotecaVirtual[];
  CALENDARIO_ACADEMICO: ItemConfig[];
  OPCOES_MENU_AJUDA: OpcoesMenuAjuda[];
  ONBOARDING_PLATAFORMA: OnboardingPlataforma;
  ONBOARDING_MODALIDADE: OnboardingModalidade;
  URL_BDQ_ALUNO: string;
  URL_BDQ_EDUCADOR: string;
  URL_TERMS: string;
  bemVindoLogin: {
    texto1: string;
    texto2: string;
  };
  descricaoAcessoLogin: {
    texto1: string;
    texto2: string;
    texto3: string;
  };
  headerMenuBiblioteca: string;
  headerMenuCalendario: string;
  labelEntrega: string;
  labelEntregas: string;
  tooltipoMenuBdq: string;
  tooltipoMenuEntregas: string;
  headerMenuEmpregabilidade: string;
  avaliacao: {
    tiposAvaliacao: {
      nome: string;
      titulo: string;
      descricao: string;
    }[];
  };
  ITENS_MENU: ItemMenuConfigValues[];
  ITENS_AVALIACOES: Avaliacao[];
}
